/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "gister",
        "-2": "eergister",
        "0": "vandag",
        "1": "môre",
        "2": "oormôre",
        "future": {
          "one": "oor {0} dag",
          "other": "oor {0} dae"
        },
        "past": {
          "one": "{0} dag gelede",
          "other": "{0} dae gelede"
        }
      },
      "day-narrow": {
        "-1": "gister",
        "-2": "eergister",
        "0": "vandag",
        "1": "môre",
        "2": "oormôre",
        "future": {
          "one": "oor {0} dag",
          "other": "oor {0} dae"
        },
        "past": {
          "one": "{0} dag gelede",
          "other": "{0} dae gelede"
        }
      },
      "day-short": {
        "-1": "gister",
        "-2": "eergister",
        "0": "vandag",
        "1": "môre",
        "2": "oormôre",
        "future": {
          "one": "oor {0} dag",
          "other": "oor {0} dae"
        },
        "past": {
          "one": "{0} dag gelede",
          "other": "{0} dae gelede"
        }
      },
      "hour": {
        "0": "hierdie uur",
        "future": {
          "one": "oor {0} uur",
          "other": "oor {0} uur"
        },
        "past": {
          "one": "{0} uur gelede",
          "other": "{0} uur gelede"
        }
      },
      "hour-narrow": {
        "0": "hierdie uur",
        "future": {
          "one": "oor {0} u.",
          "other": "oor {0} u."
        },
        "past": {
          "one": "{0} u. gelede",
          "other": "{0} u. gelede"
        }
      },
      "hour-short": {
        "0": "hierdie uur",
        "future": {
          "one": "oor {0} u.",
          "other": "oor {0} u."
        },
        "past": {
          "one": "{0} u. gelede",
          "other": "{0} u. gelede"
        }
      },
      "minute": {
        "0": "hierdie minuut",
        "future": {
          "one": "oor {0} minuut",
          "other": "oor {0} minute"
        },
        "past": {
          "one": "{0} minuut gelede",
          "other": "{0} minute gelede"
        }
      },
      "minute-narrow": {
        "0": "hierdie minuut",
        "future": {
          "one": "oor {0} min.",
          "other": "oor {0} min."
        },
        "past": {
          "one": "{0} min. gelede",
          "other": "{0} min. gelede"
        }
      },
      "minute-short": {
        "0": "hierdie minuut",
        "future": {
          "one": "oor {0} min.",
          "other": "oor {0} min."
        },
        "past": {
          "one": "{0} min. gelede",
          "other": "{0} min. gelede"
        }
      },
      "month": {
        "-1": "verlede maand",
        "0": "vandeesmaand",
        "1": "volgende maand",
        "future": {
          "one": "oor {0} maand",
          "other": "oor {0} maande"
        },
        "past": {
          "one": "{0} maand gelede",
          "other": "{0} maande gelede"
        }
      },
      "month-narrow": {
        "-1": "verlede md.",
        "0": "hierdie md.",
        "1": "volgende md.",
        "future": {
          "one": "oor {0} md.",
          "other": "oor {0} md."
        },
        "past": {
          "one": "{0} md. gelede",
          "other": "{0} md. gelede"
        }
      },
      "month-short": {
        "-1": "verlede md.",
        "0": "hierdie md.",
        "1": "volgende md.",
        "future": {
          "one": "oor {0} md.",
          "other": "oor {0} md."
        },
        "past": {
          "one": "{0} md. gelede",
          "other": "{0} md. gelede"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "verlede kwartaal",
        "0": "hierdie kwartaal",
        "1": "volgende kwartaal",
        "future": {
          "one": "oor {0} kwartaal",
          "other": "oor {0} kwartale"
        },
        "past": {
          "one": "{0} kwartaal gelede",
          "other": "{0} kwartale gelede"
        }
      },
      "quarter-narrow": {
        "-1": "verlede kwartaal",
        "0": "hierdie kwartaal",
        "1": "volgende kwartaal",
        "future": {
          "one": "oor {0} kw.",
          "other": "oor {0} kw."
        },
        "past": {
          "one": "{0} kw. gelede",
          "other": "{0} kw. gelede"
        }
      },
      "quarter-short": {
        "-1": "verlede kwartaal",
        "0": "hierdie kwartaal",
        "1": "volgende kwartaal",
        "future": {
          "one": "oor {0} kw.",
          "other": "oor {0} kw."
        },
        "past": {
          "one": "{0} kw. gelede",
          "other": "{0} kw. gelede"
        }
      },
      "second": {
        "0": "nou",
        "future": {
          "one": "oor {0} sekonde",
          "other": "oor {0} sekondes"
        },
        "past": {
          "one": "{0} sekonde gelede",
          "other": "{0} sekondes gelede"
        }
      },
      "second-narrow": {
        "0": "nou",
        "future": {
          "one": "oor {0} s.",
          "other": "oor {0} s."
        },
        "past": {
          "one": "{0} s. gelede",
          "other": "{0} s. gelede"
        }
      },
      "second-short": {
        "0": "nou",
        "future": {
          "one": "oor {0} s.",
          "other": "oor {0} s."
        },
        "past": {
          "one": "{0} s. gelede",
          "other": "{0} s. gelede"
        }
      },
      "week": {
        "-1": "verlede week",
        "0": "hierdie week",
        "1": "volgende week",
        "future": {
          "one": "oor {0} week",
          "other": "oor {0} weke"
        },
        "past": {
          "one": "{0} week gelede",
          "other": "{0} weke gelede"
        }
      },
      "week-narrow": {
        "-1": "verlede w.",
        "0": "hierdie w.",
        "1": "volgende w.",
        "future": {
          "one": "oor {0} w.",
          "other": "oor {0} w."
        },
        "past": {
          "one": "{0} w. gelede",
          "other": "{0} w. gelede"
        }
      },
      "week-short": {
        "-1": "verlede w.",
        "0": "hierdie w.",
        "1": "volgende w.",
        "future": {
          "one": "oor {0} w.",
          "other": "oor {0} w."
        },
        "past": {
          "one": "{0} w. gelede",
          "other": "{0} w. gelede"
        }
      },
      "year": {
        "-1": "verlede jaar",
        "0": "hierdie jaar",
        "1": "volgende jaar",
        "future": {
          "one": "oor {0} jaar",
          "other": "oor {0} jaar"
        },
        "past": {
          "one": "{0} jaar gelede",
          "other": "{0} jaar gelede"
        }
      },
      "year-narrow": {
        "-1": "verlede j.",
        "0": "hierdie j.",
        "1": "volgende j.",
        "future": {
          "one": "oor {0} j.",
          "other": "oor {0} j."
        },
        "past": {
          "one": "{0} j. gelede",
          "other": "{0} j. gelede"
        }
      },
      "year-short": {
        "-1": "verlede j.",
        "0": "hierdie j.",
        "1": "volgende j.",
        "future": {
          "one": "oor {0} j.",
          "other": "oor {0} j."
        },
        "past": {
          "one": "{0} j. gelede",
          "other": "{0} j. gelede"
        }
      }
    },
    "locale": "af-NA"
  });
}